module.exports = __webpack_public_path__ + "img/short-icon.90b6b14b.svg";